import dayjs from 'dayjs';

// Brand palette (mirrors src/assets/style/_variables.styl + statistics charts)
export const SERIES_COLORS = {
    logins: '#7096D2',
    meditated: '#A5BEA4'
};

/**
 * Chart.js dataset structure for the daily trend.
 * @param {Array<{date: string, uniqueLogins: number, uniqueMeditated: number}>} daily
 * @param {{ logins: string, meditated: string }} labels legend labels
 */
export function buildChartData(daily, labels) {
    const dense = daily.length > 45;
    const point = color => ({
        borderColor: color,
        pointBackgroundColor: color,
        pointBorderColor: color,
        pointRadius: dense ? 0 : 3,
        pointHitRadius: 12,
        borderWidth: 2,
        lineTension: 0.25,
        fill: true
    });

    return {
        labels: daily.map(day => dayjs(day.date).format('MM/DD')),
        datasets: [
            {
                label: labels.logins,
                data: daily.map(day => day.uniqueLogins),
                backgroundColor: 'rgba(112, 150, 210, 0.18)',
                ...point(SERIES_COLORS.logins)
            },
            {
                label: labels.meditated,
                data: daily.map(day => day.uniqueMeditated),
                backgroundColor: 'rgba(165, 190, 164, 0.18)',
                ...point(SERIES_COLORS.meditated)
            }
        ]
    };
}

/** True when at least one day has a login or a practice. */
export function hasActivity(daily) {
    return daily.some(day => day.uniqueLogins > 0 || day.uniqueMeditated > 0);
}

/** The day with the most unique logins, or null when there is no activity. */
export function peakDay(daily) {
    return daily.reduce((best, day) => {
        if (day.uniqueLogins <= 0) return best;
        return !best || day.uniqueLogins > best.uniqueLogins ? day : best;
    }, null);
}
